import {createContext, useState} from "react";

export const EmailLogContext = createContext({})

export const Provider = (props) => {
    const {children} = props;

    const [emailLog, setEmailLog] = useState(null);
    const [emailLogs, setEmailLogs] = useState([]);
    const [emailLogDialog, setEmailLogDialog] = useState(false);

    // Make the context object:
    const emailLogContext = {
        emailLog,
        setEmailLog,
        emailLogs,
        setEmailLogs,
        emailLogDialog,
        setEmailLogDialog,
    };

    // pass the value in provider and return
    return <EmailLogContext.Provider value={emailLogContext}>{children}</EmailLogContext.Provider>;
}

export const {Consumer} = EmailLogContext;
